import type { APIResult } from "./types";

import { getMaintenanceBrakeTests } from "./generated/calls/maintenance-brake-tests/maintenance-brake-tests";
import type { MaintenanceBrakeTests as MaintenanceBrakeTestDTO } from "./generated/models";
import { buildHeaders } from "./helpers/headerHelper";
import { postgrestError } from "./helpers/postgrestErrorHelper";

export type { MaintenanceBrakeTestDTO };

/**
 * Fetches all fleet maintenance brake tests from the API.
 *
 * Returns an API result containing the fetched brake tests, or a
 * controlled failure if the request could not be completed.
 */
export async function fetchFleetMaintenanceBrakeTests(): Promise<
  APIResult<MaintenanceBrakeTestDTO[]>
> {
  try {
    const headers = buildHeaders();
    const brakeTestsFetchRes = await getMaintenanceBrakeTests(undefined, {
      headers,
    });

    switch (brakeTestsFetchRes.status) {
      // A read narrowed by `limit`, `offset` or a `Range` header answers 206
      // and carries the same rows as a 200.
      case 200:
      case 206:
        return {
          success: true,
          data: brakeTestsFetchRes.data,
        };
      default:
        throw postgrestError("Fetch failed", brakeTestsFetchRes);
    }
  } catch (error) {
    return {
      success: false,
      errorMsg:
        error instanceof Error ? error.message : "an unknown error occurred",
    };
  }
}
